export const ADD_MEMBER_SUCCESS = "member/create_member_success";
export const ADD_MEMBER_FAIL = "member/create_member_fail";

export const UPDATE_MEMBER_SUCCESS = "member/update_member_success";
export const UPDATE_MEMBER_FAIL = "member/update_member_fail";

export const GET_MEMBER_SUCCESS = "member/get_member_success";
export const GET_MEMBER_FAIL = "member/get_member_fail";

export const DELETE_MEMBER_SUCCESS = "member/delete_member_success";
export const DELETE_MEMBER_FAIL = "member/delete_member_fail";